/**
 * Loading States & Skeleton Screens
 * Professional loading UX for index page
 */

(function() {
  'use strict';
  
  // Configuration
  const config = {
    skeletonFadeOut: 300, // ms
    imageLoadDelay: 50, // Stagger image loading
  };
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    initImageLoadingStates();
    initCategorySliderSkeleton();
    initProductCardSkeletons();
  }
  
  // Image loading states with fade-in
  function initImageLoadingStates() {
    const images = document.querySelectorAll('img[loading="lazy"], img.lazyload');
    
    images.forEach((img, index) => {
      // Add blur-up effect class
      img.classList.add('blur-up');
      
      // Listen for load event
      const onLoad = () => {
        setTimeout(() => {
          img.classList.add('loaded');
          img.classList.remove('blur-up');
        }, index * config.imageLoadDelay);
      };
      
      if (img.complete) {
        onLoad();
      } else {
        img.addEventListener('load', onLoad);
        img.addEventListener('error', () => {
          img.classList.remove('blur-up');
          img.classList.add('error');
        });
      }
    });
  }
  
  // Category slider skeleton screen
  function initCategorySliderSkeleton() {
    const sliderWrappers = document.querySelectorAll('.category-slider-wrapper');
    
    sliderWrappers.forEach(wrapper => {
      const sliders = wrapper.querySelectorAll('.category-slider');
      
      sliders.forEach(slider => {
        const track = slider.querySelector('.slider-track');
        if (!track) return;
        
        const products = track.querySelectorAll('.category-product');
        
        // If no products yet, show skeleton
        if (products.length === 0) {
          showSliderSkeleton(track);
        } else {
          // Add loading class and remove when images are loaded
          track.classList.add('is-loading');
          
          let loadedCount = 0;
          const images = track.querySelectorAll('img');
          const totalImages = images.length;
          
          if (totalImages === 0) {
            track.classList.remove('is-loading');
            return;
          }
          
          images.forEach(img => {
            const onLoad = () => {
              loadedCount++;
              if (loadedCount >= totalImages) {
                setTimeout(() => {
                  track.classList.remove('is-loading');
                  track.classList.add('loaded');
                }, config.skeletonFadeOut);
              }
            };
            
            if (img.complete) {
              onLoad();
            } else {
              img.addEventListener('load', onLoad);
              img.addEventListener('error', onLoad);
            }
          });
        }
      });
    });
  }
  
  function showSliderSkeleton(track) {
    const skeleton = createSkeletonProducts(3);
    track.innerHTML = skeleton;
    track.classList.add('is-skeleton');
    
    // Check periodically if real products have loaded
    const checkInterval = setInterval(() => {
      const realProducts = track.querySelectorAll('.category-product:not(.skeleton-product)');
      if (realProducts.length > 0) {
        clearInterval(checkInterval);
        setTimeout(() => {
          track.classList.remove('is-skeleton');
          const skeletons = track.querySelectorAll('.skeleton-product');
          skeletons.forEach(s => s.remove());
        }, config.skeletonFadeOut);
      }
    }, 100);
  }
  
  function createSkeletonProducts(count) {
    let html = '';
    for (let i = 0; i < count; i++) {
      html += `
        <div class="category-product skeleton-product" style="animation-delay: ${i * 0.1}s">
          <div class="skeleton skeleton-image" style="aspect-ratio: 1; border-radius: 14px;"></div>
          <div class="skeleton skeleton-text" style="width: 80%; height: 1.2em; margin: 1rem auto 0.5rem;"></div>
          <div class="skeleton skeleton-text" style="width: 40%; height: 1em; margin: 0 auto;"></div>
        </div>
      `;
    }
    return html;
  }
  
  // Product card skeletons
  function initProductCardSkeletons() {
    const productContainers = document.querySelectorAll('.collection-with-images, .products-grid');
    
    productContainers.forEach(container => {
      const products = container.querySelectorAll('[data-product-item]');
      
      products.forEach(product => {
        product.classList.add('is-loading');
        
        const images = product.querySelectorAll('img');
        let loadedCount = 0;
        
        if (images.length === 0) {
          product.classList.remove('is-loading');
          return;
        }
        
        images.forEach(img => {
          const onLoad = () => {
            loadedCount++;
            if (loadedCount >= images.length) {
              setTimeout(() => {
                product.classList.remove('is-loading');
                product.classList.add('loaded');
              }, config.skeletonFadeOut);
            }
          };
          
          if (img.complete) {
            onLoad();
          } else {
            img.addEventListener('load', onLoad);
            img.addEventListener('error', onLoad);
          }
        });
      });
    });
  }
  
  // Add skeleton screen CSS
  function addSkeletonStyles() {
    const style = document.createElement('style');
    style.textContent = `
      /* Loading state opacity */
      .is-loading {
        opacity: 0.6;
        pointer-events: none;
      }
      
      .loaded {
        opacity: 1;
        pointer-events: auto;
        transition: opacity ${config.skeletonFadeOut}ms ease-in-out;
      }
      
      /* Skeleton product fade-in */
      .skeleton-product {
        animation: skeleton-fade-in 0.4s ease-out both;
      }
      
      @keyframes skeleton-fade-in {
        from {
          opacity: 0;
          transform: translateY(10px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      
      /* Hide skeleton when track is loaded */
      .slider-track:not(.is-skeleton) .skeleton-product {
        display: none;
      }
      
    `;
    document.head.appendChild(style);
  }
  
  addSkeletonStyles();
  
  // Expose API
  window.LoadingStates = {
    showSkeleton: showSliderSkeleton,
    createSkeletonProducts: createSkeletonProducts,
  };
})();
